import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BUTTON_CLICK } from 'src/app/components/shared/modal/warning-modal/warning-modal.constants';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { LocationProfilePopupComponent } from '../location-profile-popup.component';
import { FOOTER_LABEL } from '../location-profile.constants';

@Component({
  selector: 'app-footer-action-bar',
  templateUrl: './footer-action-bar.component.html',
  styleUrls: ['./footer-action-bar.component.scss'],
  standalone: false,
})
export class FooterActionBarComponent implements OnChanges {
  readonly CONSTANTS = {
    ...FOOTER_LABEL,
  };
  readonly IMAGES = IMAGE_SRC;

  @Input() form!: FormGroup;
  @Input() btnEnabled = false;
  @Input() resetBtnEnabled = false;
  @Input() edit = false;
  @Input() btnText = this.CONSTANTS.NEXT;
  @Output() submitBtnClick = new EventEmitter();
  @Output() resetBtnClick = new EventEmitter();

  constructor(
    private commonUtils: CommonUtils,
    public readonly dialogRef: MatDialogRef<LocationProfilePopupComponent>,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.btnEnabled) {
      this.btnEnabled = changes.btnEnabled?.currentValue || false;
    }
    if (changes.resetBtnEnabled) {
      this.resetBtnEnabled = changes.resetBtnEnabled?.currentValue || false;
    }
  }

  reset() {
    // persist initial state of the form
    this.resetBtnClick.emit({});
  }

  cancel() {
    this.commonUtils
      .openWarningModal({
        header: this.CONSTANTS.CANCEL_MODAL.HEADER,
        body: this.CONSTANTS.CANCEL_MODAL.BODY,
        confirmButtonText: this.CONSTANTS.CANCEL_MODAL.CONFIRM_BUTTON,
        rejectButtonText: this.CONSTANTS.CANCEL_MODAL.REJECT_BUTTON,
      })
      .afterClosed()
      .subscribe((resp) => {
        if (resp.button === BUTTON_CLICK.ACCEPT) {
          this.dialogRef.close();
        }
      });
  }
}
